import React, { useEffect, useState } from "react";
import styles from "./ProgressBar.module.css";

const lightenColor = (hex, percent = 8) => {
  if (!hex.startsWith("#")) return hex;

  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;

  // Move each channel toward 255 (white)
  r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
  g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
  b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));

  return `rgb(${r}, ${g}, ${b})`;
};

const ProgressBar = ({
  dateTimesLive,
  dataArrLive,
  chartChannel,
  minVal,
  maxVal,
  rotate,
  fontSize,
  bgColor
}) => {
  const [currentValue, setCurrentValue] = useState();
  const [percentage, setPercentage] = useState();
  const [isRotate, setIsRotate] = useState();

  useEffect(() => {
    setIsRotate(rotate);
    const matchedDatasets =
      chartChannel?.length > 0
        ? chartChannel?.map((label) =>
          dataArrLive?.find((dataset) => dataset.label === label)
        )
        : [];

    const currentVal =
      matchedDatasets.length > 0 ? matchedDatasets[0]?.data.slice(-1) : [1];
    if (currentVal) {
      const newPercentage = ((currentVal[0] - minVal) / (maxVal - minVal)) * 100
      setCurrentValue(currentVal[0]);
      console.log("percentage:", newPercentage);

      setPercentage(newPercentage);
    }
  }, [dateTimesLive, chartChannel, minVal, maxVal, rotate]);

  return (
    <div
      className={styles.progressBar}
      style={{
        transform: isRotate ? "rotate(-90deg)" : null,
        transition: 'transform 0.4s linear'
      }}
    >
      <div
        className={styles.minValue}
        style={{
          transform: isRotate ? "rotate(90deg)" : null,
          color: bgColor ? bgColor : "#5273e6",
        }}
      >
        {minVal}
      </div>
      <div
        className={styles.valSection}
        style={{ gap: isRotate ? "0.3rem" : null }}
      >
        <div
          className={styles.currentValue}
          style={{
            transform: isRotate ? "rotate(90deg)" : null,
            padding: rotate ? "0.5rem" : null,
            fontSize: fontSize ? fontSize + "px" : "3.5rem",
            color: bgColor ? bgColor : "#5273e6",
          }}
        >
          {currentValue}
        </div>
        <div
          className={styles.emptyProgressBar}
          style={{
            width: "100%",
          }}
        >
          <div
            className={styles.fillingProgressBar}
            style={{
              left: percentage - 100 + "%",
              transition: "2s",
              background: bgColor ? `linear-gradient(
                to right,
                ${bgColor},
                ${lightenColor(bgColor, 50)}
              )` : `linear-gradient(to right, #666fcc, #9c77d3)`
            }}
          ></div>
        </div>
      </div>
      <div
        className={styles.maxValue}
        style={{
          transform: isRotate ? "rotate(90deg)" : null,
          padding: isRotate ? "0rem 0.5rem 0rem 0rem" : null,
          color: bgColor ? bgColor : "#5273e6",
        }}
      >
        {maxVal}
      </div>
    </div>
  );
};

const NewProgressBar = ({
  dateTimesLive,
  dataArrLive,
  chartChannel,
  minVal,
  maxVal,
  chartIndex,
  rotateBar,
  fontSize,
  bgColor,
}) => {
  const [currentValue, setCurrentValue] = useState();
  const [percentage, setPercentage] = useState();

  useEffect(() => {

    const matchedDatasets =
      (Array.isArray(chartChannel) && chartChannel.length > 0)
        ? dataArrLive?.find(
          (dataset) => dataset.label === chartChannel[0]
        )
        : null;

    console.log("chartChannel:", chartChannel);
    const currentVal = matchedDatasets
      ? matchedDatasets?.data.slice(-1)
      : [100];
    const newPercentage = ((currentVal[0] - minVal) / (maxVal - minVal)) * 100


    setCurrentValue(currentVal[0]);
    setPercentage(newPercentage);
  }, [dateTimesLive, chartChannel, minVal, maxVal]);

  return (
    <div className={styles.progressBar} style={{
      transform: rotateBar ? "rotate(-90deg)" : null,
    }}>
      <div className={styles.minValue} style={{
        transform: rotateBar ? "rotate(90deg)" : null,
        color: bgColor ? bgColor : "#5273e6",
      }}>{minVal ? minVal : 0}</div>

      <div className={styles.valSection}
        style={{ gap: rotateBar ? "0.3rem" : null }}
      >
        <div className={styles.currentValue}
          style={{
            transform: rotateBar ? "rotate(90deg)" : null,
            padding: rotateBar ? "0.5rem" : null,
            fontSize: fontSize ? fontSize + "px" : "3.5rem",
            color: bgColor ? bgColor : "#5273e6",
          }}
        >{currentValue}</div>
        <div className={styles.emptyProgressBar} style={{ width: "100%" }}>
          <div
            className={styles.fillingProgressBar}
            style={{
              left: percentage - 100 + "%",
              transition: "2s",
              background: bgColor ? `linear-gradient(
                to right,
                ${bgColor},
                ${lightenColor(bgColor, 50)}
              )` : `linear-gradient(to right, #666fcc, #9c77d3)`
            }}
          ></div>
        </div>
      </div>
      <div className={styles.maxValue}
        style={{
          transform: rotateBar ? "rotate(90deg)" : null,
          padding: rotateBar ? "0rem 0.5rem 0rem 0rem" : null,
          color: bgColor ? bgColor : "#5273e6",
        }}
      >
        {maxVal ? maxVal : 100}
      </div>
    </div>
  );
};

export { ProgressBar, NewProgressBar };